import React from "react";
import { Outlet } from "react-router-dom";

function Category() {
  return <Outlet />;
}

export default Category;
